import { useQueries } from '@tanstack/react-query';

import { assetKeys } from '@/shared/lib/query/queryKeys';

import { fetchTableColumnsCount } from '@/features/asset-detail/api/tableColumnsCountApi';

export const useTableColumnsCount = (tableFqns: string[], includeDeleted: boolean = false) => {
  const queries = useQueries({
    queries: tableFqns.map((fqn) => ({
      queryKey: assetKeys.tableColumnsCount(fqn, includeDeleted),
      queryFn: () => fetchTableColumnsCount(fqn, includeDeleted),
      staleTime: 5 * 60 * 1000,
      retry: 1,
    })),
  });

  const countsMap = new Map<string, number>();
  const errorsMap = new Map<string, boolean>();
  const isLoading = queries.some((q) => q.isLoading);
  const hasError = queries.some((q) => q.isError);

  queries.forEach((query, index) => {
    const fqn = tableFqns[index];
    if (query.data !== undefined) {
      countsMap.set(fqn, query.data);
    }
    if (query.isError) {
      errorsMap.set(fqn, true);
    }
  });

  return {
    countsMap,
    errorsMap,
    isLoading,
    hasError,
  };
};
